module.exports = __webpack_public_path__ + "img/about-12.6abc62d8.jpg";